import React from 'react';
import Modal from 'react-modal';
import { InjectedRouter } from 'react-router';
import Button from 'components/Button';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { Props as SuccessViewProps } from 'coaching/components/CoachingSelfServeView/CoachingSelfServeSuccessView';
import CoachingSelfServeAddChildAccountModal from 'coaching/components/CoachingSelfServeView/CoachingSelfServeAddChildAccountModal';
import CoachingSelfServeReservationDetails from 'coaching/components/CoachingSelfServeView/CoachingSelfServeReservationDetails';
import Copy from 'components/Copy';
import Display from 'components/Display';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import Link from 'components/Link';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import { withRouter } from 'app/context/Router';

import Illustration from 'assets/images/coaching/postpurchase_illustration.svg';

function CoachingSelfServePostPurchaseView(
  props: SuccessViewProps & {
    router: InjectedRouter;
  }
) {
  const eventKeyPrefix = 'coaching.self_schedule_purchase.success';
  React.useEffect(() => {
    EventTracking.trackKey(`${eventKeyPrefix}.view`);
  }, []);

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const { reservation, userTimezone, childName } = props;

  return (
    <React.Fragment>
      <Modal isOpen={modalIsOpen}>
        <CoachingSelfServeAddChildAccountModal
          onRequestHide={() => setModalIsOpen(false)}
          onAddChild={() => props.router.push('/classes')}
          participantUUID={props.participantUUID}
          userEmail={props.userEmail}
          eventKeyScreen="self_schedule_purchase"
        />
      </Modal>
      <Row size="small">
        <Text size="small">The date and time are set!</Text>
      </Row>
      <div>
        {reservation && childName && (
          <CoachingSelfServeReservationDetails
            reservation={reservation}
            childName={childName}
            userTimezone={userTimezone}
          />
        )}
      </div>
      <Divider size="large" />
      <CoachingHeading>Next: Add your child to the session</CoachingHeading>
      <Row size="small">
        <Copy size="medium">
          Once they log in, they can share homework and join the session from their own account.
          You’ll still stay in the loop with notifications.
        </Copy>
      </Row>
      <Row size="medium">
        <MediaObject figure="right" center>
          <Text color="thunder" size="medium">
            <Row size="xsmall">
              <Text size="xsmall" weight="semibold">
                Recommended for:
              </Text>
            </Row>
            <List size="small">
              <ListItem>Students in middle or high school</ListItem>
              <ListItem>Students with online assignments</ListItem>
            </List>
          </Text>
          <Display hide="480">
            <Image src={Illustration} width={200} />
          </Display>
        </MediaObject>
      </Row>
      <MediaObject center>
        <Button
          color="koolaid"
          level="primary"
          size="medium"
          onClick={() => setModalIsOpen(true)}
          eventKey={`${eventKeyPrefix}.add_student_account.click`}>
          Add account
        </Button>
        <Link
          color="ink"
          underline
          weight="semibold"
          to="/"
          eventKey={`${eventKeyPrefix}.skip.click`}>
          <Text size="small">No thanks, continue with my account</Text>
        </Link>
      </MediaObject>
    </React.Fragment>
  );
}

export default withRouter(CoachingSelfServePostPurchaseView);
